import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Dropdown, DropdownButton, Row, Col } from 'react-bootstrap';
import {useHistory} from "react-router-dom";
import {Icon} from "./components";
import styled from "styled-components";
import {COLORS as COLOR} from "./theme";

function Title(props) {

	const hasActions = () => {
		return props.children && props.children.length > 0;
	}

	function Actions() {
		const { group } = {group: true, ...props}

		const children = props.children && React.Children.toArray(props.children).filter( x => !!x )

		if (children && children.length > 0) {
			if (children.length == 1 || !group) {
				return React.Children.map(children, child => {
					if (React.isValidElement(child)) {
		        return React.cloneElement(child, { ...child.props, className: "float-right", style:{marginLeft: "0.25rem"} });
		      }
		      return child;
				})
			} else {
				return (
					<DropdownButton
		        as={ButtonGroup}
		        variant="primary"
		        title={props.groupedTitle || "actions"}
		        className="float-right"
		      >
		      	{React.Children.map(children, child => {
		      		return (<Dropdown.Item {...child.props}>
		      			{child.props.children}
		      		</Dropdown.Item>)
		      	})}
					</DropdownButton>
				)
			}
		} else {
			return null
		}
	}

  return (
    <Row className="page-title align-items-center">
      {(props.onBack || props.backPath) && <Back onBack={props.onBack} backPath={props.backPath}/>}
      <Col>
        {props.main && <h1>{props.main} { props.sub && '|' } <span>{props.sub}</span></h1>}
      </Col>
      { hasActions && <Col md="auto">
      	<Actions />
			</Col>}
    </Row>
  )
}

const BackButton = styled.button`
  position: absolute;
  transform: translate(-60%);
  width: 30px;
  padding-top: 3px;
  border: none;
  color: ${COLOR.midGrey}
`

function Back({onBack, backPath}) {
  const history = useHistory();
  const handleClick = () => onBack ? onBack() : history.push(backPath)

  return (
    <BackButton onClick={handleClick}><Icon icon='caret-left' size='2x'/></BackButton>
  )
}

Title.propTypes = {
  main: PropTypes.oneOfType([
		PropTypes.string, PropTypes.element
	]),
  sub: PropTypes.oneOfType([
		PropTypes.string, PropTypes.element
	]),
  // children: PropTypes.arrayOf(PropTypes.element),
  group: PropTypes.bool
}

export default Title
